import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLatexComponent } from './simple-icons-latex.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLatexComponent ],
    exports:      [ SimpleIconsLatexComponent ],
    bootstrap:    []
})
export class SimpleIconsLatexModule {}
